function attachVariantHoverListeners() {
  // Iterate over each product card
  document.querySelectorAll('.grid__item .product-card-wrapper').forEach(function (productCard) {
    // Select the product image within the product card
    const productImage = productCard.querySelector('.card__media .media img');

    // Save the original srcset and src as data attributes on the image element
    if (!productImage.hasAttribute('data-original-srcset')) {
      productImage.setAttribute('data-original-srcset', productImage.srcset);
    }

    if (!productImage.hasAttribute('data-original-src')) {
      productImage.setAttribute('data-original-src', productImage.src);
    }

    const variantPillsContainer = productCard.querySelector('.variant__pills');

    if (variantPillsContainer) {
      variantPillsContainer.querySelectorAll('.variant__pill').forEach(function (pill) {
        pill.addEventListener('mouseenter', function () {
          const newSrcSet = pill.querySelector('span').getAttribute('data-srcset');
          const newSrc = pill.querySelector('span').getAttribute('data-src');

          productImage.classList.add('fade-out');
          setTimeout(function () {
            productImage.srcset = newSrcSet;
            productImage.src = newSrc;
            productImage.classList.remove('fade-out');
            productImage.classList.add('fade-in');
          }, 300);
        });
      });

      variantPillsContainer.addEventListener('mouseleave', function () {
        productImage.classList.add('fade-out');
        setTimeout(function () {
          // Roll back to the original srcset and src from the data attributes
          const originalSrcSet = productImage.getAttribute('data-original-srcset');
          const originalSrc = productImage.getAttribute('data-original-src');
          
          productImage.srcset = originalSrcSet;
          productImage.src = originalSrc;
          
          productImage.classList.remove('fade-out');
          productImage.classList.add('fade-in');
        }, 300);
      });
    }
  });
}

function observeElement(elementToObserve) {
  attachVariantHoverListeners();
  
  if (elementToObserve) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          attachVariantHoverListeners();
        }
      });
    });

    observer.observe(elementToObserve, {
      childList: true,
      subtree: true,
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('.product-grid-container');
  observeElement(productGrid); // Pass in the element to observe
});